module.exports = __webpack_public_path__ + "static/media/grid_grad.44ac0ad7.svg";